import { CloseButton, Input } from '@mantine/core';
import React from 'react';
import { useNavigate } from 'react-router';

import { ReactComponent as GoBack } from '../../../../shared/assets/arrowLeft.svg';
import { ContentLayout } from '../../../../shared/ui/ContentLayout';
import { Header } from '../../../../shared/ui/Header';
import { TaskSearch } from '../../../../widgets/search/TaskSearch';

export const SearchPage = () => {
  const navigate = useNavigate();
  const [value, setValue] = React.useState('');
  const deferredValue = React.useDeferredValue(value);

  return (
    <>
      <Header leftIcon={<GoBack onClick={() => navigate(-1)} />}>
        <Input
          autoFocus
          placeholder="Поиск"
          rightSection={
            <CloseButton
              data-id="clearBtn"
              onClick={() => setValue('')}
              style={{ display: value ? undefined : 'none' }}
            />
          }
          rightSectionPointerEvents="all"
          value={value}
          variant="unstyled"
          onChange={(e) => setValue(e.currentTarget.value)}
        />
      </Header>
      <ContentLayout>
        <TaskSearch value={deferredValue} />
      </ContentLayout>
    </>
  );
};
